module.exports = __webpack_public_path__ + "img/stroke-1.c79286a7.svg";